var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseImageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_684_10523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.7207 15.7764C8.7207 10.2535 13.1979 5.77637 18.7207 5.77637C24.2436 5.77637 28.7207 10.2535 28.7207 15.7764C28.7207 21.2992 24.2436 25.7764 18.7207 25.7764C13.1979 25.7764 8.7207 21.2992 8.7207 15.7764Z",
    fill: "#090A0A",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5288 11.5844C14.7728 11.3403 15.1686 11.3403 15.4126 11.5844L18.7207 14.8925L22.0288 11.5844C22.2728 11.3403 22.6686 11.3403 22.9126 11.5844C23.1567 11.8285 23.1567 12.2242 22.9126 12.4683L19.6046 15.7764L22.9126 19.0844C23.1567 19.3285 23.1567 19.7242 22.9126 19.9683C22.6686 20.2124 22.2728 20.2124 22.0288 19.9683L18.7207 16.6603L15.4126 19.9683C15.1686 20.2124 14.7728 20.2124 14.5288 19.9683C14.2847 19.7242 14.2847 19.3285 14.5288 19.0844L17.8368 15.7764L14.5288 12.4683C14.2847 12.2242 14.2847 11.8285 14.5288 11.5844Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_684_10523",
    x: 0.720703,
    y: -2.22363,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_684_10523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_684_10523",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseImageIcon);
export default __webpack_public_path__ + "static/media/closeImageIcon.697ea03d0085aec13539da720266b24f.svg";
export { ForwardRef as ReactComponent };